import { ApparentPowerUnits } from "@/libs/units/apparentPower";
import { GenericUnits } from "@/libs/units/generic";
import { PercentageUnits } from "@/libs/units/percentage";
import { PowerUnits } from "@/libs/units/power";
import { computeVsdLabel } from "@/models/equipment/vsd/properties";
import type { RenderScenarioExportCols } from "./sizingExportTypes";
import { computeSwitchboardLabel } from "@/models/equipment/switchboards/properties";

export const renderControllerCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "CONTROLLER",
    label: "Controller Description",
    targetUnit: null,
    value: scenario.scenario.value?.equipment?.use_vsd
      ? `VSD - ${computeVsdLabel(scenario.scenario.value?.equipment?.r_vsd)}`
      : `SWB - ${computeSwitchboardLabel(
          scenario.scenario.value?.equipment?.r_switchboard
        )}`
  },
  {
    section: "CONTROLLER",
    label: "Controller Surface KVA Required",
    targetUnit: ApparentPowerUnits.KiloVoltAmps,
    value: calcs.surfaceDriveCalculations.requiredKVA.value,
    disableConversion: true
  },
  {
    section: "CONTROLLER",
    label: "Controller System Power Required",
    targetUnit: targetUnits.realPowerUnit,
    value: PowerUnits.KiloWatts.toStandardUnit(
      calcs.surfaceDriveCalculations.systemPowerKW.value
    )
  },
  {
    section: "CONTROLLER",
    label: "Controller System Power Factor",
    targetUnit: GenericUnits.Generic,
    value: calcs.surfaceDriveCalculations.surfacePFRatio.value
  },
  {
    section: "CONTROLLER",
    label: "Total System Efficiency",
    targetUnit: PercentageUnits.Percentage,
    value: PercentageUnits.Ratio.toStandardUnit(
      calcs.surfaceDriveCalculations.totalSystemEfficiencyRatio.value
    ),
    hidden: !calcs.isScenarioEspShore.value
  },
  {
    section: "CONTROLLER",
    label: "Controller Monthly System Power Cost",
    targetUnit: GenericUnits.UnitedStatesDollar,
    value: calcs.surfaceDriveCalculations.monthlySystemCostUSD.value,
    hidden: !calcs.isScenarioEspShore.value
  },
  {
    section: "CONTROLLER",
    label: "System Emissions Generated",
    targetUnit: null,
    value: calcs.surfaceDriveCalculations.systemEmissionsCO2T.value
  },
  {
    section: "CONTROLLER",
    label: "Controller Input Voltage",
    targetUnit: targetUnits.voltageUnit,
    value: scenario.parameters.value?.vsd_input_voltage
  },
  {
    section: "CONTROLLER",
    label: "Controller Output Voltage",
    targetUnit: targetUnits.voltageUnit,
    value: scenario.equipment.value?.up_trans_id
      ? calcs.surfaceDriveCalculations.vsdOutputVoltageV.value
      : calcs.surfaceDriveCalculations.requiredVoltageV
  }
];
